import { render } from "./userpaymentlist.vue?vue&type=template&id=42f84b0c&scoped=true"
import script from "./userpaymentlist.vue?vue&type=script&lang=js"
export * from "./userpaymentlist.vue?vue&type=script&lang=js"

import "./userpaymentlist.vue?vue&type=style&index=0&id=42f84b0c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f84b0c"]])

export default __exports__